import { handleResponse } from './response.service';
import { getAccessToken } from './authConfig';
import { apiUrl } from './config';

async function buildHeaders(path, extraHeaders = {}) {
    const headers = { 'Content-Type': 'application/json', ...extraHeaders };
    if (path.includes('token=')) {
        return headers;
    }
    const token = await getAccessToken();
    headers.Authorization = `Bearer ${token}`;
    return headers;
}

async function getData(path) {
    const headers = await buildHeaders(path);
    const res = await fetch(apiUrl + path, { method: 'GET', headers });
    return handleResponse(res);
}

async function patchData(path, bodyData) {
    const headers = await buildHeaders(path);
    const res = await fetch(apiUrl + path, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(bodyData),
    });
    return handleResponse(res);
}

async function postData(path, bodyData) {
    const headers = await buildHeaders(path);
    const res = await fetch(apiUrl + path, {
        method: 'POST',
        headers,
        body: JSON.stringify(bodyData),
    });
    return handleResponse(res);
}

async function postFormData(path, formData) {
    const token = await getAccessToken();
    const res = await fetch(apiUrl + path, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
    });
    return handleResponse(res);
}

async function deleteData(path) {
    const headers = await buildHeaders(path);
    const res = await fetch(apiUrl + path, { method: 'DELETE', headers });
    return handleResponse(res);
}

export const apiService = {
    getData,
    patchData,
    postData,
    postFormData,
    deleteData,
};
